import apiService from '../services/api';
import { downloadBlob } from './downloadBlob';
import { isNativePlatform } from './platform';

/**
 * Open a file served by an authenticated API route. A plain `<a href>` to such
 * a route is a browser navigation with no bearer token, and the server answers
 * "No token provided". So the file is fetched through the API client and shown
 * from a blob: URL in a new tab; in the app, or where the tab is blocked, it is
 * saved instead.
 *
 * `path` is relative to the API base, as for any `apiService` call. Call it
 * straight from a click handler: the tab has to be opened before the fetch, or
 * the browser treats it as a pop-up.
 */
export async function openDocument(path: string, filename: string): Promise<void> {
  const tab = isNativePlatform() ? null : window.open('', '_blank');
  try {
    const blob = await (apiService.get(path, { responseType: 'blob', timeout: 60000 }) as unknown as Promise<Blob>);
    if (!tab) {
      downloadBlob(blob, filename);
      return;
    }
    const url = URL.createObjectURL(blob);
    tab.location.href = url;
    // The tab has the file once it has loaded; the URL only needs to outlive that.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    tab?.close();
    throw err;
  }
}
